module.exports = __webpack_public_path__ + "img/kissing-cat.2a208d92.png";